export function zipWith() {
    var args = Array.from(arguments);
    if (typeof args[0] === 'function' && args.length === 1) {
        return function (f, s) {
            return _zipWith(f, s, args[0]);
        };
    }
    if (typeof args[0] === 'function' && args.length === 2) {
        return function (f) {
            return _zipWith(f, args[1], args[0]);
        };
    }
    if (args.length === 3) {
        return _zipWith(args[0], args[1], args[2]);
    }
}
function _zipWith(first, second, fn) {
    var resultLength = first.length > second.length ? second.length : first.length;
    var result = [];
    for (var i = 0; i < resultLength; i++) {
        result.push(fn(first[i], second[i]));
    }
    return result;
}
